import React from 'react'
import {BLOCKS} from '@contentful/rich-text-types'
import {documentToReactComponents} from '@contentful/rich-text-react-renderer'

import Zoom from 'react-reveal/Zoom'

const options =  {
    renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => <p>{children}</p>,
    }
}
const Other = ({story, name, location, color}) => (

    <Zoom >

        <article className={`sm:rounded-3xl px-12 py-12  mb-3 sm:mb-0 w-full bg-${color}`}>
            {/* {console.log(story)} */}
            <content>
                {console.log(JSON.parse(story))}
                {documentToReactComponents(JSON.parse(story), options)}
            </content>
            <footer className="font-bold mt-3">
                {name}, {location}
            </footer>
        </article>
    </Zoom>
)

export default Other